import React, { useEffect, useState } from "react";
import {
  Container, Card, CardBody, CardHeader, Table, Button, Modal, ModalHeader,
  ModalBody, ModalFooter, Input, Label, Row, Col, Badge, Spinner,
} from "reactstrap";
import api from "./api";
import { aviso } from '../../../lib/dialogo';

const EMPTY = { cliente_id: "", descricao: "", valor: "", vencimento: "", status: "pendente", linha_digitavel: "", link_pdf: "" };
const STATUS = { pendente: "warning", pago: "success", vencido: "danger", cancelado: "secondary" };
const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const dataBR = (d) => (d ? new Date(d).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : "—");

const Boletos = () => {
  const [lista, setLista] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState("");

  const carregar = async () => {
    setLoading(true);
    try {
      const [b, c] = await Promise.all([api.get("/oplena/boletos"), api.get("/oplena/clientes")]);
      setLista(b || []); setClientes(c || []);
    } catch (e) { setErro(e.message); } finally { setLoading(false); }
  };
  useEffect(() => { carregar(); }, []);

  const abrirNovo = () => { setForm(EMPTY); setErro(""); setModal(true); };
  const abrirEdicao = (b) => {
    setForm({ ...EMPTY, ...b, cliente_id: b.cliente_id || "", vencimento: b.vencimento ? b.vencimento.slice(0, 10) : "" });
    setErro(""); setModal(true);
  };

  const salvar = async () => {
    if (!form.descricao.trim()) { setErro("Informe a descrição."); return; }
    setSaving(true); setErro("");
    const payload = { ...form, cliente_id: form.cliente_id || null, valor: Number(form.valor) || 0, vencimento: form.vencimento || null };
    try {
      if (form.id) await api.put(`/oplena/boletos/${form.id}`, payload);
      else await api.post("/oplena/boletos", payload);
      setModal(false); await carregar();
    } catch (e) { setErro(e.message); } finally { setSaving(false); }
  };

  const marcarPago = async (b) => {
    try { await api.put(`/oplena/boletos/${b.id}`, { ...b, status: "pago" }); await carregar(); }
    catch (e) { aviso(e.message, 'error'); }
  };
  const excluir = async (b) => {
    if (!window.confirm("Excluir este boleto?")) return;
    try { await api.del(`/oplena/boletos/${b.id}`); await carregar(); } catch (e) { aviso(e.message, 'error'); }
  };

  const total = lista.filter((b) => b.status === "pendente").reduce((s, b) => s + Number(b.valor || 0), 0);

  return (
    <div className="page-content">
      <Container fluid>
        <Card>
          <CardHeader className="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div>
              <h4 className="mb-0 fw-bold">Boletos</h4>
              <small className="text-muted">Pendente: <span className="fw-semibold">{brl(total)}</span></small>
            </div>
            <Button color="primary" onClick={abrirNovo}><i className="fa-solid fa-plus me-1" /> Novo boleto</Button>
          </CardHeader>
          <CardBody>
            {loading ? (
              <div className="text-center py-5"><Spinner /></div>
            ) : lista.length === 0 ? (
              <div className="text-center text-muted py-5">Nenhum boleto cadastrado.</div>
            ) : (
              <Table responsive hover className="align-middle mb-0">
                <thead>
                  <tr><th>Descrição</th><th>Cliente</th><th>Valor</th><th>Vencimento</th><th>Status</th><th className="text-end">Ações</th></tr>
                </thead>
                <tbody>
                  {lista.map((b) => (
                    <tr key={b.id}>
                      <td className="fw-semibold">{b.descricao}</td>
                      <td>{b.cliente_nome || "—"}</td>
                      <td>{brl(b.valor)}</td>
                      <td>{dataBR(b.vencimento)}</td>
                      <td><Badge color={STATUS[b.status] || "secondary"}>{b.status}</Badge></td>
                      <td className="text-end">
                        {b.link_pdf && <a className="btn btn-sm btn-outline-primary me-1" href={b.link_pdf} target="_blank" rel="noopener" title="Abrir PDF"><i className="fa-solid fa-file-pdf" /></a>}
                        {b.status !== "pago" && <Button size="sm" color="outline-success" className="me-1" title="Marcar pago" onClick={() => marcarPago(b)}><i className="fa-solid fa-check" /></Button>}
                        <Button size="sm" color="outline-secondary" className="me-1" onClick={() => abrirEdicao(b)}><i className="fa-solid fa-pen" /></Button>
                        <Button size="sm" color="outline-danger" onClick={() => excluir(b)}><i className="fa-solid fa-trash" /></Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>

        <Modal isOpen={modal} toggle={() => setModal(false)} centered>
          <ModalHeader toggle={() => setModal(false)}>{form.id ? "Editar boleto" : "Novo boleto"}</ModalHeader>
          <ModalBody>
            {erro && <div className="alert alert-danger py-2">{erro}</div>}
            <Row className="g-3">
              <Col md={12}><Label>Descrição *</Label><Input value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} /></Col>
              <Col md={6}><Label>Cliente</Label>
                <Input type="select" value={form.cliente_id || ""} onChange={(e) => setForm({ ...form, cliente_id: e.target.value })}>
                  <option value="">— sem cliente —</option>
                  {clientes.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
                </Input>
              </Col>
              <Col md={3}><Label>Valor (R$)</Label><Input type="number" step="0.01" value={form.valor} onChange={(e) => setForm({ ...form, valor: e.target.value })} /></Col>
              <Col md={3}><Label>Vencimento</Label><Input type="date" value={form.vencimento || ""} onChange={(e) => setForm({ ...form, vencimento: e.target.value })} /></Col>
              <Col md={6}><Label>Status</Label>
                <Input type="select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                  {Object.keys(STATUS).map((s) => <option key={s} value={s}>{s}</option>)}
                </Input>
              </Col>
              <Col md={6}><Label>Linha digitável</Label><Input value={form.linha_digitavel || ""} onChange={(e) => setForm({ ...form, linha_digitavel: e.target.value })} /></Col>
              <Col md={12}><Label>Link do PDF</Label><Input value={form.link_pdf || ""} onChange={(e) => setForm({ ...form, link_pdf: e.target.value })} placeholder="https://..." /></Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={() => setModal(false)}>Cancelar</Button>
            <Button color="primary" onClick={salvar} disabled={saving}>{saving ? "Salvando..." : "Salvar"}</Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default Boletos;
